var map = {
	"./border-bg-sm.png": 1388,
	"./border-bg.png": 1389,
	"./btn-active.png": 1390,
	"./cny-flower-1.webp": 1391,
	"./cny-flower-2.webp": 1392,
	"./cny-mobile-bg.webp": 1393,
	"./content-deco-1.webp": 1394,
	"./content-deco-2.webp": 1395,
	"./content-deco-3.webp": 1396,
	"./content-deco-4.webp": 1397,
	"./content-deco-5.webp": 1398,
	"./deposit-icon.webp": 1399,
	"./home-icon-active.webp": 1400,
	"./home-icon.webp": 1401,
	"./live-icon-active.webp": 1402,
	"./live-icon.webp": 1403,
	"./master-bg.png": 1404,
	"./me-icon-active.webp": 1405,
	"./me-icon.webp": 1406,
	"./platform.webp": 1407,
	"./product-overview-bg.webp": 1408,
	"./promos-icon-active.webp": 1409,
	"./promos-icon.webp": 1410,
	"./sponsor-icon-active.webp": 1411,
	"./sponsor-icon.webp": 1412,
	"./title-deco-bg.webp": 1413,
	"./title-deco-left.webp": 1414,
	"./title-deco-right.webp": 1415,
	"./vip-icon-active.webp": 1416,
	"./vip-icon.webp": 1417,
	"./withdraw-icon.webp": 1418,
	"./wwr-bg.webp": 1419,
	"./wwr-img.webp": 1420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;